import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function FinalCTA() {
  return <section className="py-12 md:py-20 lg:py-24 bg-clinical-deep text-white" data-id="element-51">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-8 md:mb-10" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-4" data-id="element-54">
            Última oportunidad
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black mb-7 md:mb-9 leading-[1.05] text-white uppercase" data-id="element-55">
            El precio{' '}
            <span className="accent-italic-gold normal-case" data-id="element-56">cierra en</span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex justify-center mb-8 md:mb-12" data-id="element-57">
            <Countdown data-id="element-58" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-8 md:mb-10" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 rounded-3xl p-6 md:p-8 border border-white/10 flex flex-col h-full text-center md:text-left" data-id="element-60">
            <h4 className="text-lg md:text-xl font-black mb-2 text-white uppercase" data-id="element-61">
              Mega Pack Enfermería
            </h4>
            <p className="text-white/60 text-sm mb-5" data-id="element-62">6 Tomos + 6 Bonos</p>

            <div className="mb-6" data-id="element-63">
              <span className="line-through text-white/40 mr-3 text-base font-medium" data-id="element-64">
                $51.000
              </span>
              <span className="text-3xl md:text-4xl font-black text-white" data-id="element-65">
                $19.990{' '}
                <span className="text-base font-semibold text-white/60" data-id="element-66">
                  ARS
                </span>
              </span>
            </div>

            <a href="#pricing" className="mt-auto w-full py-3.5 md:py-4 rounded-full border border-white/30 text-white font-semibold text-sm md:text-base hover:bg-white/10 transition-colors text-center inline-flex justify-center items-center gap-2 uppercase tracking-wide" data-id="element-67">
              Quiero el Mega Pack
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-6 md:p-8 flex flex-col h-full text-clinical-deep relative text-center md:text-left" data-id="element-68">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 md:left-auto md:right-6 md:translate-x-0 bg-clinical-accent text-clinical-deep text-[10px] font-bold uppercase tracking-[0.22em] py-1.5 px-3 rounded-full whitespace-nowrap" data-id="element-69">
              Recomendado
            </div>

            <h4 className="text-lg md:text-xl font-black mb-2 mt-2 uppercase" data-id="element-70">
              Mega Pack + Avanzado
            </h4>
            <p className="text-clinical-ink/70 text-sm mb-5" data-id="element-71">
              6 Tomos + 6 Bonos + 30 casos clínicos
            </p>

            <div className="mb-6" data-id="element-72">
              <span className="line-through text-clinical-ink/40 mr-3 text-base font-medium" data-id="element-73">
                $69.000
              </span>
              <span className="text-3xl md:text-4xl font-black text-clinical-deep" data-id="element-74">
                $27.990{' '}
                <span className="text-base font-semibold text-clinical-ink/60" data-id="element-75">
                  ARS
                </span>
              </span>
            </div>

            <a href="#pricing" className="mt-auto w-full py-3.5 md:py-4 rounded-full bg-clinical-accent text-clinical-deep font-bold text-sm md:text-base hover:bg-clinical-accentLight transition-colors text-center inline-flex justify-center items-center gap-2 uppercase tracking-wide" data-id="element-76">
              Quiero el Pack + Avanzado
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs sm:text-sm text-white/60 max-w-3xl mx-auto text-center" data-id="element-77">
          <div className="flex items-center gap-1.5" data-id="element-78">
            <Lock size={14} className="text-white/50" data-id="element-79" />
            <span data-id="element-80">Pago 100% seguro</span>
          </div>
          <span className="text-white/20" data-id="element-81">·</span>
          <div className="flex items-center gap-1.5" data-id="element-82">
            <ShieldCheck size={14} className="text-white/50" data-id="element-83" />
            <span data-id="element-84">Acceso en 5 minutos</span>
          </div>
          <span className="text-white/20" data-id="element-85">·</span>
          <div className="flex items-center gap-1.5" data-id="element-86">
            <ShieldCheck size={14} className="text-white/50" data-id="element-87" />
            <span data-id="element-88">Garantía 7 días</span>
          </div>
          <span className="text-white/20" data-id="element-89">·</span>
          <div className="flex items-center gap-1.5" data-id="element-90">
            <CreditCard size={14} className="text-white/50" data-id="element-91" />
            <span data-id="element-92">Mercado Pago</span>
          </div>
        </motion.div>
      </div>
    </section>;
}